export function checkPasswordStrength(password = "") {
  let strength = 0;
  let obj = {
    color: "",
    text: "",
  };

  if (!password) return obj;
  if (password.match(/[a-z]+/)) {
    strength += 1;
  }
  if (password.match(/[A-Z]+/)) {
    strength += 1;
  }
  if (password.match(/[0-9]+/)) {
    strength += 1;
  }
  if (password.match(/[@$!%*#?&-]+/)) {
    strength += 1;
  }

  switch (strength) {
    case 0:
      obj = {
        color: "darkred",
        text: "WEAK",
      };
      break;

    case 1:
      obj = {
        color: "orangered",
        text: "WEAK",
      };
      break;

    case 2:
      if (password?.length < 8) {
        return {
          strength: 1,
          obj: {
            color: "orangered",
            text: "WEAK",
          },
        };
      }
      obj = {
        color: "orange",
        text: "AVERAGE",
      };
      break;

    case 3:
      if (password?.length < 8) {
        return {
          strength: 2,
          obj: {
            color: "orange",
            text: "AVERAGE",
          },
        };
      }
      obj = {
        color: "yellowgreen",
        text: "GOOD",
      };
      break;

    case 4:
      if (password?.length < 8) {
        return {
          strength: 3,
          obj: {
            color: "yellowgreen",
            text: "GOOD",
          },
        };
      }
      obj = {
        color: "green",
        text: "STRONG",
      };
      break;
    default:
      return {
        strength: 0,
        obj: {
          color: "",
          text: "",
        },
      };
  }
  return {
    strength,
    obj,
  };
}
